export const INTERCOM_HELP_URL = 'https://help.hirenimble.com';
